export default __webpack_public_path__ + "static/media/Dice-4.0742f0e7.png";